import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import Style from './NFTModule.module.scss';
import Header from './components/Header';
import Description from './components/Description';
import NFTTitle from './components/NFTTitle';
import NFTThumbnail from './components/NFTThumbnail';
import DropTimer from './components/DropTimer';
import DropCTA from './components/DropCTA';
import Thumbnail from './components/Thumbnail';
import { isDropped, isCurrentDay } from './NFThelper';

const NFTModule = ({
  ctaText = '',
  dropUrl = '',
  endDate = '',
  images = {},
  nftName = '',
  videos = {},
}) => {
  const [isSameDay, setIsSameDay] = useState(isCurrentDay(endDate));
  const [isDropActive, setIsDropActive] = useState(isDropped(endDate));
  const onWholeBannerClick = () => {
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_item_title: nftName,
        page_action_location: 'whole banner',
      },
    });
  };

  const onCtaBannerClick = () => {
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_button_text: ctaText,
        page_action_location: 'cta',
      },
    });
  };

  return (
    <>
      <div className={Style.gradientDivider} />
      <section onClick={onWholeBannerClick}>
        <div className={Style.container}>
          {images?.left && (
            <div className={Style.NFTContainer}>
              <NFTTitle title={nftName} />
              <NFTThumbnail image={images?.left} video={videos?.nftDefaultLeft?.url} />
            </div>
          )}
          {images?.left && <div className={Style.divider} />}
          <div
            className={classnames(
              Style.contentContainer,
              !images.left && Style.noPrevContentContainer,
            )}
          >
            <div className={classnames(Style.content, isDropActive && Style.activeDropContent)}>
              <Header isSameDay={isSameDay} isDropActive={isDropActive} />
              <Description isSameDay={isSameDay} isDropActive={isDropActive} />
              <DropTimer
                isDropActive={isDropActive}
                setIsSameDay={setIsSameDay}
                setIsDropActive={setIsDropActive}
                dropTime={endDate}
              />
              <DropCTA ctaText={ctaText} dropUrl={dropUrl} onCtaBannerClick={onCtaBannerClick} />
            </div>
            <Thumbnail
              image={images?.right}
              video={videos?.nftDefaultRight?.url}
              noPrevious={!images.left}
            />
          </div>
        </div>
      </section>
    </>
  );
};

NFTModule.propTypes = {
  ctaText: PropTypes.string,
  dropUrl: PropTypes.string,
  endDate: PropTypes.string,
  images: PropTypes.shape({}),
  nftName: PropTypes.string,
  videos: PropTypes.shape({}),
};

export default NFTModule;
